import { Numerals } from "@/types/Numerals";
import { SupportedLocale } from "@/types/SupportedLocale";

export const MUI_LOCALES = ["enUS", "arEG"] as const;

const ar_numerals = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"] as const;

export const LANG_NUMERALS: Partial<Record<SupportedLocale, Numerals>> = {
  ar: ar_numerals,
} as const;
